import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import './Header.css';
// Import the logo from assets/images
import logoImg from '../assets/images/MAISON.png';

const Header = () => {
    const [menuOpen, setMenuOpen] = useState(false);
    const location = useLocation();

    const toggleMenu = () => {
        setMenuOpen(!menuOpen);
    };

    const closeMenu = () => {
        setMenuOpen(false);
    };

    // Function to check if link is active
    const isActive = (path) => {
        return location.pathname === path ? 'active' : '';
    };

    return (
        <header className="header">
            <div className="header-container">
                <div className="logo">
                    <Link to="/" onClick={closeMenu}>
                        <img 
                            src={logoImg} 
                            alt="Maison Mosh II" 
                            className="logo-image"
                        />
                    </Link>
                </div>
                
                {/* Hamburger Menu Button */}
                <div className={`hamburger ${menuOpen ? 'active' : ''}`} onClick={toggleMenu}>
                    <span></span>
                    <span></span>
                    <span></span>
                </div>
                
                {/* Navigation Menu */}
                <nav className={`nav-menu ${menuOpen ? 'active' : ''}`}>
                    <ul>
                        <li><Link to="/" className={isActive('/')} onClick={closeMenu}>Home</Link></li>
                        <li><Link to="/about" className={isActive('/about')} onClick={closeMenu}>About</Link></li>
                        <li><Link to="/gallery" className={isActive('/gallery')} onClick={closeMenu}>Gallery</Link></li>
                        <li><Link to="/rooms" className={isActive('/rooms')} onClick={closeMenu}>Rooms</Link></li>
                    
                        <li><Link to="/contact" className={isActive('/contact')} onClick={closeMenu}>Contact</Link></li>
                    </ul>
                    {/* Mobile CTA Button */}
                    <div className="mobile-cta">
                        <Link to="/rooms" onClick={closeMenu}>Book Now</Link>
                    </div>
                </nav>
                
                {/* Desktop CTA Button */}
                <div className="header-cta">
                    <Link to="/rooms" className="book-now-btn" onClick={closeMenu}>Book Now</Link>
                </div>
            </div>
        </header>
    );
};

export default Header;